import { useEffect } from 'react';

/**
 * Use this to set the window title.
 * @returns nothing
 */
export default function useDocumentTitle(
  title: LocalizedString | null | undefined
) {
  useEffect(() => {
    if (title) {
      window.document.title =
        title.length > 0 ? `${title} – Watershed` : 'Watershed';
    }
  }, [title]);
}
